"use client";

import { VideoIds } from "@/constants";
import { getHeroBanner, isHeroBanner } from "./hero-banner";
import { videoStorage } from "./video-local-storage";

export const playVideo = (videoElement: HTMLVideoElement | null) => {
  if (!videoElement) return;

  const currentVideoId = videoElement.id;

  const allVideos = Array.from(document.getElementsByTagName("video"));

  Promise.allSettled(allVideos.map((el) => el.id !== currentVideoId && el.id !== VideoIds.Employee && el.pause())).then(
    () => {
      videoElement.muted = true;
      videoElement?.play();
      const isHero = isHeroBanner(videoElement);

      if (isHero) return;
      videoStorage.set(videoElement);
      const heroBanner = getHeroBanner();

      if (!heroBanner) return;

      heroBanner.pause();
    }
  );
};
